import React, { useState } from 'react'

export default function About(props) {
  
  // const [myStyle,setmyStyle]=useState({
  //   color:'black',
  //   backgroundColor:'white',
  //   border:'1px solid grey'
  // })

  // const toggleStyle=()=>{
  //   if(myStyle.color==='black'){
  //     setmyStyle({
  //       color:'white',
  //       backgroundColor:'black',
  //       border:'1px solid white'
  //     })
  //     setbtntext('Enable Light Mode')
  //   }
  //   else{
  //     setmyStyle({
  //       color:'black',
  //       backgroundColor:'white',
  //       border:'1px solid grey'
  //     })
  //     setbtntext('Enable Dark Mode')
  //   }
  

  // const [btntext,setbtntext]=useState('Enable Dark Mode');

let myStyle={
  color: props.mode==='dark'?'white':'#042743',
  backgroundColor: props.mode==='dark'?'#042743':'white',
  border:'1px solid white'
}


  return (
    <div className='container pb-2' style={myStyle} >
      <h1>About Us</h1>
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={myStyle}>
              <strong>Analyze Your Test</strong>
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div className="accordion-body"style={myStyle}>
              TextUtils gives you a way to analyze your test quickly and efficiently. Be it word count, character count etc.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={myStyle}>
              <strong>Free to use</strong>
            </button>
          </h2>
          <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
            <div className="accordion-body " style={myStyle}>
              TextUtils is a free character tool that provides instant character count & word count statistics for a given text. TextUtils reports the number of words and Charachters. Thus it is suitable for writing text with word/ character limit.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingThree">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={myStyle}>
              <strong>Browser Compatible</strong>
            </button>
          </h2>
          <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
            <div className="accordion-body"style={myStyle}>
              This word counter software works in any web browsers such as Chrome, FireFox, Internet Explorer, Safari, Opera. It suits to count Charachters in facebook, blog, excel document, pdf document, esssays,
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container">
      <button onClick={toggleStyle} type="button" class="btn btn-primary my-3">{btntext}</button>
      </div> */}
    </div>
  )
}
